const modules = {
	accordionComponent: "accordion",
	autoCompleteInputComponent: "auto-complete-input",
	checkboxComponent: "checkbox",
	contactPersonsComponent: "contact-persons",
	contentSliderComponent: "content-slider",
	cookmodeComponent: "cookmode",
	datepickerComponent: "datepicker",
	feedbackComponent: "feedback",
	fileUploadComponent: "file-upload",
	formComponent: "form",
	formRepeatable: "form-repeatable",
	hamburgerComponent: "hamburger",
	handlePagination: "handlePagination",
	headerImageWithVideoComponent: "headerImageWithVideo",
	headerComponent: "header",
	headerTeaserComponent: "headerTeaser",
	HSContentComponent: "horizontal-scrollable-content",
	ingredientsCalculatorComponent: "ingredients-calculator",
	inputFieldComponent: "input",
	jobSearchComponent: "job-search",
	languageOverlay: "language-overlay",
	languageSwitcherComponent: "language-switcher",
	lightboxComponent: "lightboxComponent",
	mapComponent: "map",
	medienportalComponent: "medienportal",
	multiselectComponent: "multiselect",
	mealprepsetDetailComponent: "mealprepset-detail",
	newsCategoriesComponent: "news-categories",
	newsDetailComponent: "news-detail",
	newsletterOverlayComponent: "newsletter-overlay",
	newsListComponent: "news-list",
	overlayComponent: "overlay",
	productsCategoryComponent: "products-category",
	productsIndexComponent: "products-index",
	productsSliderComponent: "products-slider",
	productDetailComponent: "product-detail",
	radiofieldComponent: "radiofield",
	recipeCollectionHeaderComponent: "recipe-collection-header",
	recipeDetailComponent: "recipe-detail",
	recipesFilterComponent: "recipes-filter",
	recipesFilterDropdownComponent: "recipes-filter-dropdown",
	recipesFilterOverlayComponent: "recipes-filter-overlay",
	reviewComponent: "review",
	searchComponent: "search",
	searchInputComponent: "searchInput",
	selectComponent: "select",
	sliderContainerComponent: "sliderContainer",
	sortDropdownComponent: "sort-dropdown",
	stickyBannerComponent: "sticky-banner",
	tableAccordionComponent: "table-accordion",
	tabsComponent: "tabs",
	teaserComponent: "teaser",
	teaserListComponent: "TeaserList",
	teaserNewsletterComponent: "teaser-newsletter",
	teaserProductComponent: "teaser-product",
	teaserRecipeSearchComponent: "teaser-recipe-search",
	teaserTileComponent: "teaser-tile",
	tooltipComponent: "tooltip",
	versionDisplay: "versionDisplay",
	vimeoVideoComponent: "vimeo-video",
	youtubeVideoComponent: "youtube-video",
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.versionDisplay:
					modulePromise = import(/* webpackChunkName: "versionDisplay" */ "../components/VersionDisplay")
					break
				case modules.accordionComponent:
					modulePromise = import(/* webpackChunkName: "accordion" */ "../../components/accordion/accordion")
					break
				case modules.checkboxComponent:
					modulePromise = import(/* webpackChunkName: "checkbox" */ "../../components/checkbox/checkbox")
					break
				case modules.datepickerComponent:
					modulePromise = import(
						/* webpackChunkName: "datepicker" */ "../../components/datepicker/datepicker"
					)
					break
				case modules.fileUploadComponent:
					modulePromise = import(
						/* webpackChunkName: "fileUpload" */ "../../components/file-upload/file-upload"
					)
					break
				case modules.formComponent:
					modulePromise = import(/* webpackChunkName: "form" */ "../../components/form/form")
					break
				case modules.handlePagination:
					modulePromise = import(/* webpackChunkName: "handle-pagination" */ "../utils/HandlePagination")
					break
				case modules.headerComponent:
					modulePromise = import(/* webpackChunkName: "header" */ "../../components/header/header")
					break
				case modules.headerImageWithVideoComponent:
					modulePromise = import(
						/* webpackChunkName: "header-image-with-video" */ "../../components/header-image-with-video/header-image-with-video"
					)
					break
				case modules.headerTeaserComponent:
					modulePromise = import(
						/* webpackChunkName: "header-teaser" */ "../../components/header-teaser/header-teaser"
					)
					break
				case modules.hamburgerComponent:
					modulePromise = import(/* webpackChunkName: "hamburger" */ "../../components/hamburger/hamburger")
					break
				case modules.languageOverlay:
					modulePromise = import(
						/* webpackChunkName: "language-overlay" */ "../../components/language-overlay/language-overlay"
						)
					break
				case modules.languageSwitcherComponent:
					modulePromise = import(
						/* webpackChunkName: "language-switcher" */ "../../components/language-switcher/language-switcher"
					)
					break
				case modules.inputFieldComponent:
					modulePromise = import(
						/* webpackChunkName: "input-field" */ "../../components/inputfield/inputfield"
					)
					break
				case modules.lightboxComponent:
					modulePromise = import(/* webpackChunkName: "lightbox" */ "../components/Lightbox")
					break
				case modules.multiselectComponent:
					modulePromise = import(
						/* webpackChunkName: "multiselect" */ "../../components/multiselect/multiselect"
					)
					break
				case modules.newsletterOverlayComponent:
					modulePromise = import(
						/* webpackChunkName: "overlay" */ "../../components/newsletter-overlay/newsletter-overlay"
					)
					break
				case modules.mealprepsetDetailComponent:
					modulePromise = import(
						/* webpackChunkName: "mealprepset-detail" */ "../../components/mealprepset-detail/mealprepset-detail"
					)
					break
				case modules.overlayComponent:
					modulePromise = import(/* webpackChunkName: "overlay" */ "../../components/overlay/overlay")
					break
				case modules.radiofieldComponent:
					modulePromise = import(
						/* webpackChunkName: "radiofield" */ "../../components/radiofield/radiofield"
					)
					break
				case modules.searchComponent:
					modulePromise = import(/* webpackChunkName: "search" */ "../../components/search/search")
					break
				case modules.searchInputComponent:
					modulePromise = import(
						/* webpackChunkName: "searchInput" */ "../../components/search-input/search-input"
					)
					break
				case modules.selectComponent:
					modulePromise = import(/* webpackChunkName: "select" */ "../../components/select/select")
					break
				case modules.sliderContainerComponent:
					modulePromise = import(
						/* webpackChunkName: "slider-container" */ "../../components/slider-container/slider-container"
					)
					break
				case modules.tabsComponent:
					modulePromise = import(/* webpackChunkName: "tabs" */ "../../components/tabs/tabs")
					break
				case modules.tooltipComponent:
					modulePromise = import(/* webpackChunkName: "tooltip" */ "../../components/tooltip/tooltip")
					break
				case modules.youtubeVideoComponent:
					modulePromise = import(
						/* webpackChunkName: "youtube-video" */ "../../components/youtube-video/youtube-video"
					)
					break
				case modules.vimeoVideoComponent:
					modulePromise = import(
						/* webpackChunkName: "vimeo-video" */ "../../components/vimeo-video/vimeo-video"
					)
					break
				case modules.teaserNewsletterComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-newsletter" */ "../../components/teaser-newsletter/teaser-newsletter"
					)
					break
				case modules.sortDropdownComponent:
					modulePromise = import(
						/* webpackChunkName: "sort-dropdown" */ "../../components/sort-dropdown/sort-dropdown"
					)
					break
				case modules.stickyBannerComponent:
					modulePromise = import(
						/* webpackChunkName: "sticky-banner" */ "../../components/sticky-banner/sticky-banner"
					)
					break
				case modules.feedbackComponent:
					modulePromise = import(/* webpackChunkName: "feedback" */ "../../components/feedback/feedback")
					break
				case modules.recipesFilterDropdownComponent:
					modulePromise = import(
						/* webpackChunkName: "recipes-filter-dropdown" */ "../../components/recipes-filter-dropdown/recipes-filter-dropdown"
					)
					break
				case modules.recipesFilterComponent:
					modulePromise = import(
						/* webpackChunkName: "recipes-filter" */ "../../components/recipes-filter/recipes-filter"
					)
					break
				case modules.recipesFilterOverlayComponent:
					modulePromise = import(
						/* webpackChunkName: "recipes-filter-overlay" */ "../../components/recipes-filter-overlay/recipes-filter-overlay"
					)
					break
				case modules.productsCategoryComponent:
					modulePromise = import(
						/* webpackChunkName: "products-category" */ "../../components/products-category/products-category"
					)
					break
				case modules.productsIndexComponent:
					modulePromise = import(
						/* webpackChunkName: "products-index" */ "../../components/products-index/products-index"
					)
					break
				case modules.productsSliderComponent:
					modulePromise = import(
						/* webpackChunkName: "products-slider" */ "../../components/products-slider/products-slider"
					)
					break
				case modules.productDetailComponent:
					modulePromise = import(
						/* webpackChunkName: "product-detail" */ "../../components/product-detail/product-detail"
					)
					break
				case modules.teaserProductComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-product" */ "../../components/teaser-product/teaser-product"
					)
					break
				case modules.teaserRecipeSearchComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-recipe-search" */ "../../components/teaser-recipe-search/teaser-recipe-search"
					)
					break
				case modules.teaserTileComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-tile" */ "../../components/teaser-tile/teaser-tile"
					)
					break
				case modules.HSContentComponent:
					modulePromise = import(
						/* webpackChunkName: "horizontal-scrollable-content" */ "../../components/horizontal-scrollable-content/horizontal-scrollable-content"
					)
					break
				case modules.ingredientsCalculatorComponent:
					modulePromise = import(
						/* webpackChunkName: "ingredients-calculator" */ "../../components/ingredients-calculator/ingredients-calculator"
					)
					break
				case modules.cookmodeComponent:
					modulePromise = import(/* webpackChunkName: "cookmode" */ "../../components/cookmode/cookmode")
					break
				case modules.recipeDetailComponent:
					modulePromise = import(
						/* webpackChunkName: "recipe-detail" */ "../../components/recipe-detail/recipe-detail"
					)
					break
				case modules.recipeCollectionHeaderComponent:
					modulePromise = import(
						/* webpackChunkName: "recipe-collection-header" */ "../../components/recipe-collection-header/recipe-collection-header"
					)
					break
				case modules.newsDetailComponent:
					modulePromise = import(
						/* webpackChunkName: "news-detail" */ "../../components/news-detail/news-detail"
					)
					break
				case modules.newsListComponent:
					modulePromise = import(/* webpackChunkName: "news-list" */ "../../components/news-list/news-list")
					break
				case modules.contentSliderComponent:
					modulePromise = import(
						/* webpackChunkName: "content-slider" */ "../../components/content-slider/content-slider"
					)
					break
				case modules.teaserComponent:
					modulePromise = import(/* webpackChunkName: "teaser" */ "../../components/teaser/teaser")
					break
				case modules.reviewComponent:
					modulePromise = import(/* webpackChunkName: "review" */ "../../components/review/review")
					break
				case modules.teaserListComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-list" */ "../../components/teaser-list/teaser-list"
					)
					break
				case modules.autoCompleteInputComponent:
					modulePromise = import(
						/* webpackChunkName: "auto-complete-input" */ "../../components/auto-complete-input/auto-complete-input"
					)
					break
				default:
					// eslint-disable-next-line no-console
					console.warn("Module not found")
					break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
